import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from './dialog/dialog.module';
import { MaterialModule } from './material.module';
import { AutocompleteDireccionModule } from './autocomplete-direccion/autocomplete-direccion.module';
import { UbicarModule } from './ubicar/ubicar.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChartModule } from './chart/chart.module';
import { TablaComponent } from './tabla/tabla.component';
import { DatetimeRangePickerComponent } from './datetime-range-picker/component';
import { NombreDivisionPipe } from './nombre-division.pipe';
import { EditarClasificacionComponent } from '../modulos/clasificacion/editar-clasificacion/editar-clasificacion.component';

/**
 * `EditarClasificacionComponent` se declara y exporta ACÁ, no en
 * `ClasificacionModule`: es el editor que Topología (Task de clasificar desde
 * topología) necesita reusar sin arrastrar el `RoutingModule` propio de
 * Clasificación. `ClasificacionModule` lo sigue usando igual porque ya importa
 * este módulo.
 *
 * Por eso `DragDropModule`, `MaterialModule` y `NgSelectModule` pasan a estar
 * también en `imports` y no sólo en `exports`: lo que un módulo sólo
 * re-exporta queda disponible para quien lo importe a ÉL, pero no para las
 * plantillas de los componentes que este mismo módulo declara. El editor usa
 * `cdkDrag`, `mat-*` y `ng-select` en su propia plantilla, así que este módulo
 * los necesita de verdad, no sólo de paso.
 */
@NgModule({
  declarations: [EditarClasificacionComponent],
  imports: [
    TablaComponent,
    DatetimeRangePickerComponent,
    NombreDivisionPipe,
    FormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    DragDropModule,
    MaterialModule,
    NgSelectModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DragDropModule,
    MaterialModule,
    NgSelectModule,
    DialogModule,
    AutocompleteDireccionModule,
    UbicarModule,
    ChartModule,
    TablaComponent,
    DatetimeRangePickerComponent,
    NombreDivisionPipe,
    EditarClasificacionComponent,
  ],
})
export class AuxiliaresModule {}
